import { useEffect, useState } from "react";
import {
  ProductFilterProducts,
  ProductFilterBerand,
  CompetitorGetProductCompetitor,
  CompetitorSetProductCompetitor,
} from "../../Api/Services";
import { toast } from "react-toastify";
import InputCus from "../../Component/InputCus/Text/InputCus";
import { useNavigate, useParams } from "react-router-dom";

function CompetitorProduct() {
  const [isLoading, setLoading] = useState(true);
  const [Product, setProduct] = useState([]);
  const [ConnectProduct, setConnectProduct] = useState([]);
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [SearchName, setSearchName] = useState("");
  let { id, extra } = useParams();
  const navigate = useNavigate();

  const start = async () => {
    setProduct([]);
    setConnectProduct([]);
    try {
      const ProductFilterBerandData = await ProductFilterBerand({});
      if (
        ProductFilterBerandData.status &&
        ProductFilterBerandData.status === 200
      ) {
        setBrands(ProductFilterBerandData.data.data.data);
        const ProductFilterProductsData = await ProductFilterProducts({});
        if (
          ProductFilterProductsData.status &&
          ProductFilterProductsData.status === 200
        ) {
          setProduct(ProductFilterProductsData.data.data.data);

          var elemets = [];
          ProductFilterProductsData.data.data.data.forEach((element) => {
            let model = {
              ProductId: element.id,
              Code: "",
            };
            elemets.push(model);
          });
          const CompetitorGetProductCompetitorData =
            await CompetitorGetProductCompetitor(extra);
          if (
            CompetitorGetProductCompetitorData.status &&
            CompetitorGetProductCompetitorData.status === 200
          ) {
            CompetitorGetProductCompetitorData.data.data.forEach((element) => {
              elemets.find((e) => e.ProductId == element.productId).Code =
                element.code;
            });

            setConnectProduct(elemets);
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const Add = async () => {
    setLoading(true);
    try {
      let model = {
        CompetitorId: extra,
        Product: ConnectProduct.filter((e) => e.Code != ""),
      };
      const CompetitorSetProductCompetitorData =
        await CompetitorSetProductCompetitor(model);
      if (
        CompetitorSetProductCompetitorData.status &&
        CompetitorSetProductCompetitorData.status === 200
      ) {
        toast.success("ثبت اطلاعات  با موفقیت انجام شد");
        navigate("/Panel/Competitors/" + id);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      start();
    }
  };

  const handleChangeSearch = (id, e) => {
    const newForm = [...ConnectProduct];
    newForm.find((e) => e.ProductId == id).Code = e.target.value;
    setConnectProduct(newForm);
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
          p.productBerandId,
          p.productTypeId,
          p.productSeriesId,
          p.symbol,
          p.productSeriesEndId,
          p.productRamId,
          p.productRomId,
          p.productNetworkId,
          p.productCountryId,
          p.isInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            <div className="d-flex">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={SearchName}
                onChange={(e) => {
                  setSearchName(e.target.value);
                }}
              />
            </div>

            <div className="w-100">
              <div className="d-flex justify-content-start align-items-center w-100 m-5">
                <button onClick={Add} className="butAU">
                  ثبت
                </button>
              </div>

              {brands.map(
                (b, key) =>
                  Product.filter((e) => e.productBerandId == b.id).length >
                    0 && (
                    <>
                      <div
                        key={b}
                        className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                        onClick={() => handleClick(b.id)}
                      >
                        <h5>{b.name}</h5>
                      </div>
                      {activeItem === b.id && (
                        <div className="d-flex justify-content-center align-items-center w-100 tableC">
                          <table
                            className="table tableMore"
                            style={{ lineHeight: "normal" }}
                          >
                            <thead className="sticky-header">
                              <tr className="trTable">
                                <th>نام کالای</th>
                                <th>سیمبل کالای</th>
                                <th>رنگ</th>
                                <th>کد کالا در شرکت</th>
                              </tr>
                            </thead>

                            {Product &&
                              groupProducts(Product).map((group, gIndex) => (
                                <tbody key={gIndex}>
                                  {group
                                    .filter((itemPro) => {
                                      const productFilter =
                                        SearchName?.toUpperCase?.() || "";
                                      const Pro =
                                        (
                                          itemPro.name +
                                            " " +
                                            itemPro.productRamName +
                                            itemPro.productRamName !=" "&&"/" +
                                            itemPro.productRomName +
                                            " " +
                                            itemPro.productNetworkName +
                                            " " +
                                            itemPro.productCountryName
                                        )?.toUpperCase?.() || "";
                                      return Pro.includes(productFilter);
                                    })
                                    .filter((e) => e.productBerandId == b.id)
                                    .map((itemPro, iIndex) => {
                                      return (
                                        <tr key={itemPro.id}>
                                          {iIndex === 0 && (
                                            <>
                                              <td rowSpan={group.length}>
                                                {itemPro.name}{" "}
                                                {itemPro.productRamName}
                                                {itemPro.productRamName!=" "&&"/"}
                                                {itemPro.productRomName}{" "}
                                                {itemPro.productNetworkName}{" "}
                                                {itemPro.productCountryName}{" "}
                                              </td>
                                              <td rowSpan={group.length}>
                                                {itemPro.symbol}{" "}
                                                {itemPro.productRamName}
                                                {itemPro.productRamName!=" "&&"/"}
                                                {itemPro.productRomName}{" "}
                                                {itemPro.productNetworkName}{" "}
                                                {itemPro.productCountryName}{" "}
                                              </td>
                                            </>
                                          )}
                                          <td> {itemPro.productColorName} </td>
                                          <td>
                                            <input
                                              onChange={(e) => {
                                                handleChangeSearch(
                                                  itemPro.id,
                                                  e
                                                );
                                              }}
                                              value={
                                                ConnectProduct.find(
                                                  (e) =>
                                                    e.ProductId == itemPro.id
                                                )?.Code
                                              }
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              ))}
                          </table>
                        </div>
                      )}
                    </>
                  )
              )}
              <div className="d-flex justify-content-start align-items-center w-100 m-5">
                <button onClick={Add} className="butAU">
                  ثبت
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CompetitorProduct;
